import * as React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import Navbar from "react-bootstrap/Navbar";
import { Button, Container } from "react-bootstrap";
import logo from "../navbar/logo.png";
import { deleteCookie } from "../../utils/cookies";

const NavbarLink = ({ page, selected }) => {
  const title = (page.charAt(0).toUpperCase() + page.slice(1)) as string;

  return (
    <NavLink to={`/${page}`} className='text-dark'>
      {title}
    </NavLink>
  );
};

export function NavBar() {
  const page = useParams().page || "dashboard";

  const navigate = useNavigate();

  const GoHome = async () => {
    await deleteCookie("ea1-auth");
    navigate("/");
  };

  return (
    <>
      <EaNavbar bg='light' variant='light'>
        <Container>
          <a
            href='/'
            style={{
              padding: "0.1875em",
            }}
          >
            <img src={logo} width='53' height='45' alt='EA-Portal-1' />
            <span className='text-dark'>Admin Portal</span>
          </a>
          <NavbarDiv className='header align-items-center'>
            <NavbarLink page='dashboard' selected={page === "dashboard"} />
            <NavbarLink page='approvals' selected={page === "approvals"} />
            <NavbarLink page='providers' selected={page === "providers"} />
            <NavbarLink page='requestors' selected={page === "requestors"} />
            <NavbarLink page='services' selected={page === "services"} />
            <NavbarLink page='admin' selected={page === "admin"} />
            <Button title='logout' className='bg-warning ml-1' onClick={GoHome}>
              Logout
            </Button>
          </NavbarDiv>
        </Container>
      </EaNavbar>
    </>
  );
}

// Styled Components
const NavbarDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const NavLink = styled(Link)`
  color: #f4f4f4;
  font-weight: 600;
  text-decoration: none;
  padding: 0 5px;
`;

const EaNavbar = styled(Navbar)`
  overflow: hidden;
  z-index: 1;
  position: fixed;
  top: 0;
  width: 100%;
`;
